const defaultConfig = require("../config/default.json");

export default class AppConstants {
    getAppConstants = getConfig({});
}

// module.exports = funcs;

function getConfig({ environment }) {
    if (environment) {
        // To Do: when we have other environments in the project
    }
    // service.url (used by the `http` instance — gtt/targets/holdings/share/auth/...) always
    // stays defaultConfig.service.url (http://localhost:3006): those admin-only endpoints are
    // never meant to be reachable from the public internet, only from a machine that can reach
    // the backend directly. service.publicUrl (used by `publicApiHttp` for /public/*) is baked
    // in at build time from REACT_APP_BACKEND_HOST (see .env) in production, falling back to
    // the same localhost value in local dev where the var is left unset.
    return {
        ...defaultConfig,
        service: {
            ...defaultConfig.service,
            publicUrl: process.env.REACT_APP_BACKEND_HOST || defaultConfig.service.url,
        },
    };
}
